import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=1bd6e1e0&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd6e1e0')) {
      api.createRecord('1bd6e1e0', component.options)
    } else {
      api.reload('1bd6e1e0', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=1bd6e1e0&", function () {
      api.rerender('1bd6e1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/comp/stardisplay.vue"
export default component.exports